
// Column_item classes
export const COLUMN_ITEM_CLASS = "agenda-column-view-item";
export const COLUMN_ITEM_HANDLE_CLASS = "item-handle";
export const COLUMN_ITEM_HANDLED_CLASS = "item-handled";
export const COLUMN_ITEM_TOP_HANDLE_CLASS = "item-top-handle";
export const COLUMN_ITEM_BOTTOM_HANDLE_CLASS = "item-bottom-handle";
export const COLUMN_ITEM_SELECTED_CLASS = "item-selected";
export const ITEM_HANDLE_INTERACTION_CLASS = "item-handle-interaction";
export const ITEM_HANDLE_INTERACTION_CURSOR = "ns-resize";

/** Css class of the inner DOM displayed item */
export const COLUMN_ITEM_INNER_CLASS = "agenda-column-view-inner-item";
export const COLUMN_HOVERED_CLASS = "agenda-column-hovered";
export const COLUMN_HOVERED_NOT_ALLOWED_CLASS = "not-allowed-drag";

// Attributes
export const DATA_ITEM_UID_ATTRIBUTE = "data-item-uid";
export const DATA_COLUMN_UID_ATTRIBUTE = "data-column-uid";
